<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">ETP业务系统</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>用户盈亏统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 20px"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column label="排名" type="index" :index="indexMethod" width="100px"></el-table-column>
            <el-table-column prop="userId" label="账户ID"></el-table-column>
            <el-table-column prop="totalIncome" label="累计盈亏额（USDT）"></el-table-column>
            <el-table-column prop="totalBuyAmount" label="累计买入额（USDT）"></el-table-column>
            <el-table-column prop="totalSellAmount" label="累计卖出额（USDT）"></el-table-column>
            <el-table-column prop="incomeTopCoin" label="盈亏前三币种"></el-table-column>
            <el-table-column label="操作" fixed="right" width="100px">
                <template slot-scope="scope">
                    <el-button type="primary" @click="checkDetail(scope.row.userId)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog title="详情" :visible.sync="dialogVisible" width="1000px" @close="clearData">
            <div>账户ID:{{userId}}</div>
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" style="margin-top: 10px"
                      :data="detailList" :row-key="() => Math.random()">
                <el-table-column label="序号" type="index" :index="indexMethod" width="100px"></el-table-column>
                <el-table-column prop="coinType" label="交易币种"></el-table-column>
                <el-table-column prop="income" label="累计盈亏额（USDT）"></el-table-column>
                <el-table-column prop="buyAmount" label="累计买入额（USDT）"></el-table-column>
                <el-table-column prop="sellAmount" label="累计卖出额（USDT）"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: 'ProfitLossData',
        data() {
            return {
                dataList: [],
                total: 0,
                detailList: [],
                dialogVisible: false,
                queryParams: { //查询参数
                    page: 1,
                    size: 10
                },
                userId: ""
            };
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            },
            getUserProfitList() {
                api.getUserProfitList(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            checkDetail(userId) {
                this.userId = userId;
                api.getUserProfitDetail({userId: userId}).then(({data}) => {
                    this.detailList = data;
                    this.dialogVisible = true;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getUserProfitList();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getUserProfitList();
            },
            clearData() {
                this.detailList = [];
                this.userId = "";
            }
        },
        created() {
            this.getUserProfitList();
        }
    };
</script>

<style lang="less" scoped></style>

